<div class="modal-header">
  <h4 class="modal-title">
    <ng-container *ngIf="inputPricingMatrix !== null">
      Edit
    </ng-container>
    <ng-container *ngIf="inputPricingMatrix === null">
      Add
    </ng-container>
    Location-Specific Price
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group">
    <label>Locations</label>
    <div class="form-check ml-3" *ngFor="let location of locations">
      <input class="form-check-input" type="checkbox"
             [id]="'location-' + location.id.toString()"
             [checked]="this.pricingMatrix.location_ids.includes(location.id)"
             (change)="toggleLocationId(location.id)">
      <label class="form-check-label"
             [for]="'location-' + location.id.toString()">
        {{ location.name }}
      </label>
    </div>
  </div>

  <div class="form-group">
    <label for="initiationFeeInput">Price</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
      </div>
      <input id="initiationFeeInput" type="number" name="price"
             placeholder="XXX.XX" min="0" step="0.01"
             class="form-control"
             [(ngModel)]="pricingMatrix.price">
    </div>
    <div class="form-text text-danger">{{ errors.price }}</div>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary"
          (click)="handleSubmit()">
    Submit
  </button>
</div>
